/* eslint-disable @typescript-eslint/no-explicit-any */
import { TPanelOptions } from '@gerdau/hefesto-mais-web/InformationPanel/InformationPanel.types';
import {
  EUserPreferenceType,
  IUserPreference
} from '../../../../store/ducks/user/types';

export type SortDirection = 'asc' | 'desc';

export const defaultOrderUserPreference: IUserPreference = {
  name: EUserPreferenceType.ORDERS,
  ordersItens: {
    idOrder: '0',
    idProduct: '0'
  }
};

export interface HeaderColumnProps {
  title: string;
  column: any;
  options?: TPanelOptions[];
  debounce: ({ column, value }: { column: string; value: string }) => void;
  width?: number;
  lastColumns?: boolean;
  value?: string;
  showFilter?: boolean;
}

export const actionsOptions = ({
  onUpdateOrderClick,
  onCancelOrderClick,
  onDownloadOrderClick,
  downloadOrderTitle = 'Mostrar documentos disponíveis',
  onViewOrderClick,
  onDownloadNFE,
  onDownloadShippingNFE,
  onDownloadQC,
  onNFEAcessKey,
  onDownloadXML,
  disableViewOrderFn,
  disableUpdateOrderFn = false,
  disableDownloadOrderFn = false,
  disableCancelOrderFn = false,
  disableDownloadNFeOrderFn = false,
  disableDownloadShippingOrderFn = false,
  disableDownloadQCOrderFn = false,
  disableNFEAcessKeyOrderFn = false,
  disableDownloadXMLOrderFn = false
}: {
  onUpdateOrderClick?: () => void;
  onViewOrderClick?: () => void;
  onCancelOrderClick?: () => void;
  onDownloadOrderClick?: () => void;
  onDownloadNFE?: () => void;
  onDownloadShippingNFE?: () => void;
  onDownloadQC?: () => void;
  onNFEAcessKey?: () => void;
  onDownloadXML?: () => void;
  disableUpdateOrderFn?: boolean;
  disableViewOrderFn?: boolean;
  disableDownloadOrderFn?: boolean;
  disableCancelOrderFn?: boolean;
  disableDownloadNFeOrderFn?: boolean;
  disableDownloadShippingOrderFn?: boolean;
  disableDownloadQCOrderFn?: boolean;
  disableNFEAcessKeyOrderFn?: boolean;
  disableDownloadXMLOrderFn?: boolean;
  downloadOrderTitle?: string;
}): TPanelOptions[] => [
  ...(onViewOrderClick
    ? [
        {
          text: 'Abrir ordem de venda',
          handleOnClick: onViewOrderClick,
          disabled: disableViewOrderFn
        }
      ]
    : []),
  ...(onDownloadOrderClick
    ? [
        {
          text: downloadOrderTitle,
          handleOnClick: onDownloadOrderClick,
          disabled: disableDownloadOrderFn
        }
      ]
    : []),
  ...(onUpdateOrderClick
    ? [
        {
          text: 'Solicitar alterações',
          handleOnClick: onUpdateOrderClick,
          disabled: disableUpdateOrderFn
        }
      ]
    : []),
  ...(onCancelOrderClick
    ? [
        {
          text: 'Solicitar cancelamento',
          variant: 'danger' as const,
          handleOnClick: onCancelOrderClick,
          disabled: disableCancelOrderFn
        }
      ]
    : []),
  ...(onDownloadNFE
    ? [
        {
          text: 'Baixar 2ª via da nota fiscal',
          handleOnClick: onDownloadNFE,
          disabled: disableDownloadNFeOrderFn
        }
      ]
    : []),
  ...(onDownloadShippingNFE
    ? [
        {
          text: 'Baixar nota de remessa',
          handleOnClick: onDownloadShippingNFE,
          disabled: disableDownloadShippingOrderFn
        }
      ]
    : []),
  ...(onDownloadQC
    ? [
        {
          text: 'Baixar certificados de qualidade',
          handleOnClick: onDownloadQC,
          disabled: disableDownloadQCOrderFn
        }
      ]
    : []),
  ...(onNFEAcessKey
    ? [
        {
          text: 'Abrir chave de acesso da NF',
          handleOnClick: onNFEAcessKey,
          disabled: disableNFEAcessKeyOrderFn
        }
      ]
    : []),
  ...(onDownloadXML
    ? [
        {
          text: 'Baixar XML',
          handleOnClick: onDownloadXML,
          disabled: disableDownloadXMLOrderFn
        }
      ]
    : [])
];
